import { createStore } from "vuex"

import router from "@/router"
let localeUinfo = localStorage.getItem("userInfoMarketing") || null
let localeAdminInfo = localStorage.getItem("adminInfoMarketing") || null

let localMenuList = localStorage.getItem("menuList") || null

let offsetWid = document.documentElement.clientWidth
let isBingWin = offsetWid >= 900
export default createStore({
    state: {
        userInfo: localeUinfo ? JSON.parse(localeUinfo) : {},
        adminInfo: localeAdminInfo ? JSON.parse(localeAdminInfo) : {},
        isLoading: false,
        // permissionList: ['china'],
        isBigWin: isBingWin,
        menuList: localMenuList || [],
    },
    getters: {
        userInfo(state) {
            return state.userInfo
        },
        adminInfo(state) {
            return state.adminInfo
        },
        hasLogin(state) {
            if (typeof state.userInfo === "object" && Object.keys(state.userInfo).length > 0) {
                return true
            } else {
                return false
            }
        },
        authToken: (state) => {
            if (Object.keys(state.userInfo).length < 1) return ""
            return state.userInfo?.accessToken || ""
        },
        isSuperAdmin: (state) => {
            return state.userInfo?.super == true
        },
    },
    mutations: {
        async setUserInfo(state, e) {
            let info = e
            if (typeof e == "object") {
                state.userInfo = { ...info }
                localStorage.setItem("userInfoMarketing", JSON.stringify(state.userInfo))
            }
        },
        updateUserInfo(state, e) {
            let info = e
            if (typeof e == "object") {
                state.userInfo = { ...state.userInfo, ...info }
                localStorage.setItem("userInfoMarketing", JSON.stringify(state.userInfo))
            }
        },
        async setAdminInfo(state, e) {
            let info = e
            if (typeof e == "object") {
                state.adminInfo = { ...info }
                localStorage.setItem("adminInfoMarketing", JSON.stringify(state.adminInfo))
            }
        },
        async updateAdminInfo(state, e) {
            let info = e
            if (typeof e == "object") {
                state.adminInfo = { ...state.adminInfo, ...info }
                localStorage.setItem("adminInfoMarketing", JSON.stringify(state.adminInfo))
            }
        },
        setMenuList(state, e) {
            let info = e
            if (typeof e == "object") {
                state.menuList = info
                localStorage.setItem("menuList", state.menuList)
            }
        },
        setLoading(state, e) {
            state.isLoading = Boolean(e)
        },
        signOut(state) {
            state.userInfo = {}
            localStorage.removeItem("userInfoMarketing")
            localStorage.removeItem("adminInfoMarketing")
            router.push({
                name: "LoginView",
            })
        },
        updateMenuOpenKeys(state, e) {
            if (!e.type) return
            if (e.type == "push") {
                state.menuOpenKeys.push(e.data)
            } else if (e.type == "delete") {
                state.menuOpenKeys.splice(e.index, 1)
            }
        },
        setTempStore(state, info) {
            if (typeof info == "object") {
                return (state.tempStore = {
                    ...state.tempStore,
                    ...info,
                })
            }
        },
    },
    actions: {},
    modules: {},
})
